import { render, staticRenderFns } from "./CourceForm.vue?vue&type=template&id=f3e39f38"
import script from "./CourceForm.vue?vue&type=script&lang=js"
export * from "./CourceForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports